/**
 * The set of facing modes for camera.
 *
 * @enum {string}
 */
export const CAMERA_FACING_MODE = {
    ENVIRONMENT: 'environment',
    USER: 'user'
};

/**
 * The set of media types.
 *
 * @enum {string}
 */
export const MEDIA_TYPE = {
    AUDIO: 'audio',
    PRESENTER: 'presenter',
    SCREENSHARE: 'screenshare',
    VIDEO: 'video'
};

/**
 * The languages supported for audio files.
 */
export const AudioSupportedLanguage = {
    en: 'en',
    fr: 'fr',
    frCA: 'frCA'
};


/**
 * The types of authorities which may mute/unmute the local video.
 *
 * @enum {number}
 */
export const VIDEO_MUTISM_AUTHORITY = {
    AUDIO_ONLY: 1,
    BACKGROUND: 2,
    USER: 4,
    CAR_MODE: 8,
    SCREEN_SHARE: 16
};

/**
 * The types of video tracks.
 *
 * @enum {string}
 */
export const VIDEO_TYPE = {
    CAMERA: 'camera',
    DESKTOP: 'desktop'
};


/**
 * The types of authorities which may mute/unmute the local screenshare.
 *
 * @enum {number}
 */
export const SCREENSHARE_MUTISM_AUTHORITY = {

    AUDIO_ONLY: 1,

    USER: 4
};

/**
 * Camera-app style zoom levels for the local React Native camera. Tapping the
 * zoom button cycles through these values.
 */
export const CAMERA_ZOOM_LEVELS = [ 1, 2, 3, 6, 10 ];

export const CAMERA_ZOOM_MIN = CAMERA_ZOOM_LEVELS[0];

export const CAMERA_ZOOM_MAX = CAMERA_ZOOM_LEVELS[CAMERA_ZOOM_LEVELS.length - 1];
